import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import comCSS from "./Accordion.module.scss";
import Image from "next/image";

const Accordion = ({
  className = "",
  data = [],
  itemClassName = "",
  bodyClassName = "",
  headerClassName = "",
  headerLeftClassName = "",
  isReadMore = false,
  isCloseIconRounded = false,
  isCloseIconBlack = false,
  countN = null,
  moreText = "Read More",
  lessText = "Read Less",
  answerMaxHeight = null,
}) => {
  const [ids, setIds] = useState(new Set());

  const onToggle = (id) => {
    setIds((state) => {
      const newState = new Set([...state]);
      if (newState.has(id)) {
        newState.delete(id);
      } else {
        newState.add(id);
      }
      return newState;
    });
  };
  let closeIconSrc = "/images/home/63dbb41ebe5acc42e15b10d9_add-black.svg";
  if (isCloseIconBlack) {
    closeIconSrc = "/images/home/icon-add-white.svg";
  }

  return (
    <div className={cn(className, comCSS.wrapper, "accordion_list w-dyn-list")}>
      <div role="list" className="w-dyn-items">
        {data.map((item) => (
          <div
            role="listitem"
            className={cn("collection-item w-dyn-item", itemClassName)}
            key={item.id}
          >
            <div className="dropdown_accordion-in-cms">
              <div
                data-w-id="fdf9cff6-09fb-58c8-7b32-caba632bed77"
                className={cn(
                  "dropdown_question",
                  comCSS.question,
                  headerClassName
                )}
                onClick={() => onToggle(item.id)}
              >
                <div className={cn("dropdown-item-left", headerLeftClassName)}>
                  {item.header}
                </div>
                <div className="dropdown-item-right">
                  {isReadMore && (
                    <div
                      className={cn(
                        "small-tag black hide-tablet",
                        comCSS.readMoreBtn
                      )}
                    >
                      <div
                        className={cn({
                          "accordion-hover-tag-open": !ids.has(item.id),
                          "accordion-hover-tag-close": ids.has(item.id),
                          [comCSS.accordionHoverTagClose]: ids.has(item.id),
                        })}
                      >
                        {ids.has(item.id) ? lessText : moreText}
                      </div>
                    </div>
                  )}
                  <div className="dropdown-right-inner-wrap">
                    {countN !== null ? (
                      <div className="accordion-icon-rounded-wrap">
                        <div fs-countitems-element="value">{countN}</div>
                      </div>
                    ) : null}

                    <div
                      className={cn({
                        "accordion-icon-rounded-wrap": isCloseIconRounded,
                        "is-black": isCloseIconBlack,
                      })}
                    >
                      <Image
                        width={29}
                        height={29}
                        src={closeIconSrc}
                        loading="lazy"
                        alt=""
                        className={cn("accordion-icon", comCSS.toogleIcon, {
                          [comCSS.active]: ids.has(item.id),
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={cn("dropdown_answer", bodyClassName, comCSS.answer, {
                  [comCSS.active]: ids.has(item.id),
                })}
                style={{
                  maxHeight:
                    answerMaxHeight !== null && ids.has(item.id)
                      ? `${answerMaxHeight * 2}px`
                      : "",
                }}
              >
                <div className="margin-vertical margin-accordion-content">
                  <div className="accordion-rich-text w-richtext">
                    {item.body}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Accordion.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({}),
  isCloseIconRounded: PropTypes.bool,
  isCloseIconBlack: PropTypes.bool,
  countN: PropTypes.number,
};

export default Accordion;
